export async function loadSettings(path) {
  const response = await fetch(path)
  return await response.json()
}
